export var IDLE = 'IDLE';
export var PENDING = 'PENDING';
export var ERROR = 'ERROR';
export var SUCCESS = 'SUCCESS';
